import BezierEasing from 'bezier-easing';
import { EasingOption } from '@/helpers/entities/enums/EasingOption';
import easings from '@/helpers/entities/objects/Easings';
const delay = 500;
let timeStart;
let element;
let container;
let initialY;
let diffY;
let easingOption;
const duration = 500;
function done() {
    timeStart = false;
}
function scroll(selectedContainer, top) {
    selectedContainer.scrollTop = top;
}
function step(timestamp) {
    const easingFn = BezierEasing.apply(BezierEasing, easings[easingOption]);
    if (!timeStart) {
        timeStart = timestamp;
    }
    const timeElapsed = timestamp - timeStart;
    let progress = Math.min(timeElapsed / duration, 1);
    progress = easingFn(progress);
    scroll(container, initialY + diffY * progress);
    if (timeElapsed < duration) {
        requestAnimationFrame(step);
    }
    else {
        done();
    }
}
function scrollTop(selectedContainer) {
    let offset = selectedContainer.scrollTop;
    if (container.tagName.toLowerCase() === 'body') {
        // in firefox body.scrollTop always returns 0
        // thus if we are trying to get scrollTop on a body tag
        // we need to get it from the documentElement
        offset = offset || document.documentElement.scrollTop;
    }
    return offset;
}
function cumulativeOffset(selectedElement) {
    let top = 0;
    do {
        top += selectedElement.offsetTop || 0;
        selectedElement = selectedElement.offsetParent;
    } while (selectedElement);
    return {
        top,
    };
}
function scrollTo() {
    const cumulativeOffsetContainer = cumulativeOffset(container);
    const cumulativeOffsetElement = cumulativeOffset(element);
    const targetY = cumulativeOffsetElement.top - cumulativeOffsetContainer.top;
    initialY = scrollTop(container);
    diffY = targetY - initialY;
    requestAnimationFrame(step);
}
export function ScrollToElement(elementID, containerID, easing = EasingOption.ease) {
    const SelectedElement = document.getElementById(elementID);
    // Set html as fallback
    const SelectedContainer = document.getElementById(containerID) || document.documentElement;
    easingOption = easing;
    if (SelectedElement && SelectedContainer) {
        element = SelectedElement;
        container = SelectedContainer;
        setTimeout(() => {
            scrollTo();
        }, delay);
    }
}
